module.exports = __webpack_public_path__ + "img/service_coin.68e481a.png";